import { getTvObject, tv } from '@costar-ui/cosmos';
import flexOptions from '../../../common/flex-options/flex-options.esm.js';
import radiusOptions from '../../../common/radius-options/radius-options.esm.js';
import spacingOptions from '../../../common/space-options/spacing-options.esm.js';
import cardCommon from '../common/index.esm.js';

var cardFooterTV = getTvObject({
  base: ['flex', 'flex-row', 'justify-between', 'items-center', 'w-full', 'flex-nowrap', 'print:flex-none', 'print:pt-0', 'print:px-0'],
  variants: {
    justify: flexOptions.variants.justify,
    padding: cardCommon.padding,
    radius: radiusOptions.radiusBottom,
    gap: spacingOptions.gap,
    withDivider: {
      "true": [],
      "false": []
    }
  },
  compoundVariants: [{
    padding: 'xxs',
    withDivider: false,
    className: ['pt-px']
  }, {
    padding: 'xs',
    withDivider: false,
    className: ['pt-0.5']
  }, {
    padding: 'sm',
    withDivider: false,
    className: ['pt-1']
  }, {
    padding: 'md',
    withDivider: false,
    className: ['pt-1.5']
  }, {
    padding: 'lg',
    withDivider: false,
    className: ['pt-2']
  }, {
    padding: 'xl',
    withDivider: false,
    className: ['pt-2.5']
  }, {
    padding: '2xl',
    withDivider: false,
    className: ['pt-3']
  }, {
    padding: '3xl',
    withDivider: false,
    className: ['pt-3.5']
  }]
});
var base = tv(cardFooterTV);
var cardFooterStyles = {
  base: base
};

export { cardFooterStyles, cardFooterTV };
//# sourceMappingURL=card-footer.styles.esm.js.map
